import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Card, EmptyState, ExternalIcon } from "../../ui";
import { roleHome, useAuth } from "../../auth/AuthProvider";

/**
 * Interim page for shell destinations whose real workspace lands in a later
 * redesign phase. Honest by design (§2.2 "no dead items, ever"): each route
 * is live, states what's coming, and gives a working path to the legacy
 * surface where the job is done today. These pages delete themselves as
 * Phases 2–5 replace them.
 *
 * QA M-2 (E, REFERRAL-QA-FINDINGS): the legacy-dashboard CTA must NOT be
 * offered to the referral tier — that CTA drops the very tier we protect into
 * the legacy /agent dashboard. For referral tier we point back to their own
 * Home instead (their running estimate lives there); staff keep the legacy
 * shortcut while a workspace is still being built.
 */
function PlaceholderPage({ page }) {
  const navigate = useNavigate();
  const { role, tier } = useAuth();
  const Icon = page.icon;
  const isReferral = tier === "referral";

  return (
    <div className="shell-page">
      <div className="shell-page__titlerow">
        <h1 className="shell-page__title">{page.label}</h1>
        <Badge variant="brand">{page.phase}</Badge>
      </div>
      <Card>
        <EmptyState
          icon={Icon ? <Icon size={32} /> : null}
          title={`${page.label} is on its way`}
          message={
            isReferral
              ? page.path === "/app/commissions"
                ? `Your running estimate is on your Home page — full statements arrive with ${page.phase} of the redesign.`
                : `This arrives with ${page.phase} of the redesign.`
              : `${page.description} This workspace arrives in ${page.phase} of the redesign.`
          }
          action={
            isReferral ? (
              <Button variant="secondary" onClick={() => navigate("/app/home")}>
                Go to your Home
              </Button>
            ) : (
              <Button
                variant="primary"
                icon={<ExternalIcon size={14} />}
                onClick={() => navigate(roleHome(role))}
              >
                {page.legacyLabel || "Open the legacy dashboard"}
              </Button>
            )
          }
        />
      </Card>
    </div>
  );
}

export default PlaceholderPage;
